const memoryStore = new Map();

const getSessionStorage = () => {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage || null;
  } catch {
    return null;
  }
};

export const secureStore = {
  async getItem(key) {
    const sessionStorage = getSessionStorage();
    if (sessionStorage) {
      try {
        return sessionStorage.getItem(key);
      } catch {
        return null;
      }
    }
    return memoryStore.get(key) ?? null;
  },
  async setItem(key, value) {
    const sessionStorage = getSessionStorage();
    if (sessionStorage) {
      try {
        sessionStorage.setItem(key, value);
        return;
      } catch {
        // fall through to memory store
      }
    }
    memoryStore.set(key, value);
  },
  async removeItem(key) {
    const sessionStorage = getSessionStorage();
    if (sessionStorage) {
      try {
        sessionStorage.removeItem(key);
        return;
      } catch {
        // fall through to memory store
      }
    }
    memoryStore.delete(key);
  },
};
